"use client";

import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const easeCurve = [0.22, 1, 0.36, 1] as const;
export default function IsabelTestimonial() {
  return <section id="aboutisabeltestimonial" data-nav="light" className="relative bg-background text-foreground py-20 md:py-28 lg:py-32 overflow-hidden isolate">
      <div className="container mx-auto px-5 sm:px-8 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Left Column: Vertical Portrait with gentle framing */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          ease: easeCurve
        }} className="lg:col-span-5 relative">
            <div className="relative mx-auto max-w-md lg:max-w-none">
              <div className="relative overflow-hidden rounded-2xl md:rounded-3xl rounded-br-[80px] md:rounded-br-[120px] border border-border/80 bg-card shadow-xs">
                <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/isabel_portrait_vertical.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719083/img/isabel_portrait_vertical.webp-wvc-sizes" alt="Isabel - Accompagnante postnatale" loading="lazy" decoding="async" className="w-full h-auto object-contain object-center" src="https://slow-mama.com/wp-content/uploads/2026/10/2.jpg" />
              </div>

              {/* Gentle architectural accent line */}
              <div aria-hidden="true" className="absolute -bottom-4 -left-4 w-28 h-28 border-b border-l border-primary/30 rounded-bl-3xl pointer-events-none -z-10" />
            </div>
          </motion.div>

          {/* Right Column: Editorial story & Testimonial */}
          <div className="lg:col-span-7 flex flex-col justify-center">
            {/* Story & Headline */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            delay: 0.15,
            ease: easeCurve
          }}>
              <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl leading-[1.18] font-normal text-foreground tracking-normal mb-6"><div contenteditable="false" style={{}}>Soutien en post-partum sur mesure</div></h2>
              <p className="font-sans text-base sm:text-lg leading-relaxed text-foreground/80 mb-8 max-w-2xl font-light">Tes besoins évoluent, mon accompagnement aussi. À chaque visite, nous choisissons ensemble ce qui te ferait le plus de bien: du repos, un repas, un soin, du relais avec bébé ou un moment pour parler.</p>
            </motion.div>

            {/* CTA Button */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            delay: 0.3,
            ease: easeCurve
          }} className="mb-10 sm:mb-12">
              <Button asChild size="lg" className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-sans px-8 py-6 text-sm tracking-wide transition-all shadow-xs">
                <Link to="/ContactPage">
                  ÉCHANGER AVEC ISABEL
                </Link>
              </Button>
            </motion.div>

            <Separator className="bg-border/70 mb-10" />

            {/* Authentic Testimonial Quote */}
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            delay: 0.45,
            ease: easeCurve
          }} className="relative pl-6 border-l-2 border-primary/40">
              <Quote className="size-5 text-primary/50 mb-3" aria-hidden="true" />
              <blockquote className="font-serif text-lg sm:text-xl text-foreground/90 leading-relaxed italic mb-4 font-normal">
                « En tant que jeune maman, je n&apos;aurais jamais imaginé à quel point la
                présence d&apos;Isa serait précieuse après la naissance de notre fils.
                Elle a apporté calme, soutien et douceur dans ces premières
                semaines à la fois magnifiques et bouleversantes. Grâce à son aide
                concrète — repas, maison, présence rassurante — j&apos;ai pu me reposer,
                récupérer et créer du lien avec mon bébé. Je recommande Isa de tout
                cœur, surtout aux mamans qui vivent leur premier post-partum. »
              </blockquote>
              <footer className="font-sans text-xs sm:text-sm font-medium tracking-wide text-foreground/70 not-italic uppercase">
                — Beren, maman du bébé A.
              </footer>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}